export const loadScript = src =>
  new Promise((resolve, reject) => {
    const s = document.createElement('script');

    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });

export const getContainersInnerHTML = html => {
  return html.match(/<div class="container"[^>]*>([\s\S]*)<\/div>/)[1];
};

export const getBodyInnerHTML = html => {
  return html.match(/<body[^>]*>([\s\S]*)<\/body>/)[1];
};

export const textTransform = () => {
  return `${process.env.REACT_APP_COUNTRY === 'grc' ? 'none' : 'uppercase'}`;
}

export const linkTo = (pattern) => withUTM({ pathname: pattern });

export function withUTM(to) {
  const utm = JSON.parse(sessionStorage.getItem('utm_params') || '{}');
  const url = new URL(typeof to === 'string' ? to : to.pathname, window.location.origin);

  const currentParams = new URLSearchParams(to.search || url.search);

  Object.entries(utm).forEach(([key, value]) => {
    if (!currentParams.has(key)) {
      currentParams.set(key, value);
    }
  });

  const search = currentParams.toString();
  if (typeof to === 'string') {
    return `${url.pathname}?${search}`;
  }

  return {
    ...to,
    pathname: to.pathname || url.pathname,
    search: `?${search}`,
    state: to.state,
  };
}
export const generateUniqueId = () => {
  const randomPart = Math.floor(100000 + Math.random() * 900000); // 6-digit random number
  const timePart = Date.now().toString().slice(-4); // Last 4 digits of timestamp

  return Number(`${randomPart}${timePart}`); // Combine both
};
